import logSpeFee from './logSpeFee';
import mccmdr from './mccmdr';
import settingSpeFee from './settingSpeFee';

const settingFee = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    mccmdr,
    settingSpeFee,
    logSpeFee,
  },
};

export default settingFee;
